export const applyCtaDomainPrintLayout = (html: HTMLElement): void => {
    html.querySelectorAll<HTMLElement>('#cta-personal .domain-wrapper').forEach((wrapper) => {
        const items = Array.from(wrapper.children).filter((child): child is HTMLElement => child instanceof HTMLElement);
        const table = document.createElement('table');
        table.setAttribute('role', 'presentation');
        table.setAttribute('width', '100%');
        table.setAttribute('cellpadding', '0');
        table.setAttribute('cellspacing', '0');
        table.style.cssText = 'width: 100%; table-layout: fixed; border-collapse: collapse; border: 0;';
        const tbody = table.createTBody();

        for (let i = 0; i < items.length; i += 2) {
            const row = tbody.insertRow();
            row.style.cssText = 'page-break-inside: avoid; break-inside: avoid;';
            items.slice(i, i + 2).forEach((item, column) => {
                const cell = row.insertCell();
                cell.setAttribute('width', '50%');
                cell.setAttribute('valign', 'top');
                cell.style.cssText = 'width: 50%; vertical-align: top; border: 0; padding: 15px; text-align: left;';
                cell.style.paddingLeft = column === 0 ? '15px' : '25px';
                cell.style.paddingRight = column === 0 ? '25px' : '15px';
                if (i > 0) {
                    cell.style.paddingTop = '35px';
                }

                const image = item.querySelector('img');
                if (image) {
                    image.setAttribute('align', 'left');
                    image.setAttribute('width', '80');
                    image.setAttribute('height', '80');
                    image.style.cssText = 'float: left; width: 80px; height: 80px; margin: 0 15px 10px 0;';
                    cell.appendChild(image);
                }

                // Put the text alongside the icon rather than in a full-width block below it.
                const text = item.querySelector('div');
                if (text) {
                    cell.append(...Array.from(text.childNodes));
                }
            });
        }

        wrapper.style.cssText = 'display: block; width: 100%; margin-top: 20px;';
        wrapper.replaceChildren(table);
    });
};
